import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export function MovimentacaoDialog({ 
  open, 
  onOpenChange, 
  form, 
  setForm, 
  onSubmit, 
  onReset,
  clientes = [] 
}) {
  const handleClose = () => {
    onOpenChange(false);
    onReset?.();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
          <DialogHeader>
            <DialogTitle>
              {form.tipo === 'receita' ? '💰 Nova Receita' : '💸 Nova Despesa'}
            </DialogTitle>
            <DialogDescription>
              {form.tipo === 'receita' 
                ? 'Registre uma entrada no caixa' 
                : 'Registre uma saída do caixa'}
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Tipo</Label>
                <Select 
                  value={form.tipo} 
                  onValueChange={(v) => setForm(prev => ({ ...prev, tipo: v }))}
                >
                  <SelectTrigger data-testid="select-tipo-movimentacao">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="receita">💰 Receita</SelectItem>
                    <SelectItem value="despesa">💸 Despesa</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>Data</Label>
                <Input 
                  type="date" 
                  value={form.data}
                  onChange={(e) => setForm(prev => ({ ...prev, data: e.target.value }))}
                />
              </div>
            </div>
            
            <div>
              <Label>Descrição *</Label>
              <Input 
                value={form.descricao}
                onChange={(e) => setForm(prev => ({ ...prev, descricao: e.target.value }))}
                placeholder="Descrição da movimentação"
                required
              />
            </div>
            
            <div>
              <Label>Valor (R$) *</Label>
              <Input 
                type="number" 
                step="0.01" 
                min="0"
                value={form.valor}
                onChange={(e) => setForm(prev => ({ ...prev, valor: parseFloat(e.target.value) || 0 }))}
                placeholder="0,00"
                required
              />
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Categoria</Label>
                <Select 
                  value={form.categoria} 
                  onValueChange={(v) => setForm(prev => ({ ...prev, categoria: v }))}
                >
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="servico">Serviço</SelectItem>
                    <SelectItem value="material">Material</SelectItem>
                    <SelectItem value="aluguel">Aluguel</SelectItem>
                    <SelectItem value="salario">Salário</SelectItem>
                    <SelectItem value="imposto">Imposto</SelectItem>
                    <SelectItem value="manutencao">Manutenção</SelectItem>
                    <SelectItem value="outros">Outros</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>Centro de Custo</Label>
                <Input 
                  value={form.centro_custo}
                  onChange={(e) => setForm(prev => ({ ...prev, centro_custo: e.target.value }))}
                  placeholder="Ex: Operacional"
                />
              </div>
            </div>
            
            <div>
              <Label>Cliente (opcional)</Label>
              <Select 
                value={form.cliente_id || 'none'} 
                onValueChange={(v) => setForm(prev => ({ ...prev, cliente_id: v === 'none' ? '' : v }))}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Selecione (opcional)" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="none">Nenhum</SelectItem>
                  {clientes.map(c => (
                    <SelectItem key={c.id} value={c.id}>{c.nome}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            
            <div>
              <Label>Observações</Label>
              <Textarea 
                value={form.observacoes}
                onChange={(e) => setForm(prev => ({ ...prev, observacoes: e.target.value }))}
                placeholder="Observações adicionais..."
              />
            </div>
          </div>
          
          <DialogFooter>
            <Button type="button" variant="outline" onClick={handleClose}>
              Cancelar
            </Button>
            <Button 
              type="submit" 
              className={form.tipo === 'receita' ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'}
              data-testid="btn-salvar-movimentacao"
            >
              {form.tipo === 'receita' ? 'Registrar Receita' : 'Registrar Despesa'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
